/** English perimeter-and-area prompts (ADR 0051 part 3). Unchanged from the original inline text. */
/** A no-break space (WinAnsi 0xA0), so a question mark is never left at the head of a line. */
const NO_BREAK = String.fromCharCode(0xa0);

export const shapePrompts = {
    missingSide: (area: string) => `The area is ${area}. What is the missing side?`,
    perimeter: () => `What is the perimeter?`,
    area: () => `What is the area?`,
    // Scale Drawing (ADR 0107). The scale is a stated rate, not a story.
    scaleLine: (scale: string) => `Scale: ${scale}`,
    actualSize: () => `What are the actual length and width?`,
    actualArea: () => `What is the actual area?`,
    drawingLength: (actual: string) => `The side marked${NO_BREAK}? is actually ${actual}. How long is it on the drawing?`,
    anotherScale: (scale: string) => `The shape is drawn again with a scale of ${scale}. What are the new length and width?`,
    /** "24 m by 16 m". */
    bySize: (length: string, width: string) => `${length} by ${width}`,
};
